// ##############################
// // // TasksCard styles
// #############################

import {
  card,
  defaultFont,
  infoColor,
  warningColor,
} from "assets/jss/material-dashboard-react.jsx";

const actionCardStyle = theme => ({
  card:{
    ...card,
    margin: "30px 0 45px 0"
  },
  cardHeader: {
    flex: "none",
    ...defaultFont,
  },
  cardTitle: {
    ...defaultFont,
    float: "left",
    fontWeight: "500",
    padding: "10px 10px 10px 0",
    lineHeight: "24px",
    fontSize: "14px",
    color: infoColor
  },
  tabWrapper: {
    width: "auto",
    display: "inline-flex",
    alignItems: "inherit",
    flexDirection: "row",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      display: "flex"
    }
  },
  tabIcon: {
    float: "left",
    [theme.breakpoints.down("sm")]: {
      marginTop: "-2px"
    },
    [theme.breakpoints.down("xs")]: {
      display: "none",
    }
  },
  displayNone: {
    display: "none"
  },
  labelIcon: {
    height: "44px",
    width: "130px",
    minWidth: "72px",
    paddingLeft: "14px",
    backgroundColor: infoColor,
    marginRight:"20px",
    borderRadius: "3px",
    [theme.breakpoints.down("xs")]: {
      width: "80px",
      marginRight: "6px",
    }
  },
  tabsContainer: {
    marginTop: "4px",
    color: "#FFFFFF",
    [theme.breakpoints.down("xs")]: {
    //  display: "grid"
    }
  },
  tabs: {
    width: "110px",
    minWidth: "70px",
    paddingLeft: "12px"
  },
  cardHeaderContent: {
    flex: "none"
  },
  label: {
    lineHeight: "19px",
    textTransform: "uppercase",
    fontSize: "12px",
    fontWeight: "500",
    marginLeft: "-10px"
  },
  textColorInheritSelected: {
    transition: "background-color .4s",
    backgroundColor: warningColor
  }
});

export default actionCardStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-react/actionCardStyle.jsx